import { hashHistory } from 'react-router';

// All paths
const PATHS = {
  ACCOUNT: 'account',
};

// Exported paths
export const ACCOUNT_PATH = PATHS.ACCOUNT;

export const accountPath = () => `${ACCOUNT_PATH}`;
export const navigateToAccount = () => {
  hashHistory.push(accountPath());
};



// WEBPACK FOOTER //
// ./routes/account/navigation.js